import { FC, useMemo, useState } from "react";
import * as moment from "moment";

import { FormField, IDatePicker } from "../index";

import styles from "./IDateTimePicker.module.scss";
import classNames from "classnames";

interface IDateTimePickerProps {
  allowClear?: boolean;
  className?: string;
  dateInputReadOnly?: boolean;
  placeholder?: string;
  label?: string;
  field?: any;
  disabled?: boolean;
  format?: string;
  isRequired?: boolean;
  error?: string;
  onChange?: (value) => void;
  disableData?: unknown;
  timePlaceHodler?: string;
}

export const IDateTimePicker: FC<IDateTimePickerProps> = ({
  className,
  label,
  field,
  isRequired,
  error,
  disableData,
  disabled = false,
  allowClear = true,
  format = "DD.MM.YYYY",
  placeholder = "Дата",
  timePlaceHodler = "Время",
}) => {
  const [currentTime, setCurrentTime] = useState("");

  const currentDate = useMemo(() => {
    const date = moment(field?.value).isValid() ? moment(field.value) : null;
    setCurrentTime(date ? moment(date).format("HH:mm") : "");
    return date;
  }, [field?.value]);

  const concatDateTime = (date, time = "") => {
    const currentDate = date && date?.format("YYYY-MM-DD");
    const currentTime = time && time.length === 5 ? `T${time}:00` : "";
    return currentDate && currentTime
      ? `${currentDate}${currentTime}`
      : currentDate || "";
  };

  const handleDateOnChange = (value) => {
    const time = moment(value).isValid() ? moment(value).format("HH:mm") : "";
    if (time) {
      field.onChange(concatDateTime(value, time));
    }
  };
  const handleTimeOnChange = (e) => {
    if (e.target) {
      const time = e.target.value;
      setCurrentTime(() => time);
      if (time.length === 5) {
        field.onChange(concatDateTime(currentDate, time));
      }
    }
  };
  const handleInputTimeOnChange = (e) => {
    if (e.target) {
      setCurrentTime(() => e.target.value);
    }
  };

  return (
    <div className={classNames(styles.container, className)}>
      <IDatePicker
        field={field}
        format={format}
        placeholder={placeholder || label}
        value={currentDate}
        onChange={handleDateOnChange}
        error={error}
        allowClear={allowClear}
        disabled={disabled}
        disableData={disableData}
        isRequired={isRequired}
      />
      <FormField
        label={timePlaceHodler}
        currentValue={currentTime}
        onChange={handleTimeOnChange}
        onInput={handleInputTimeOnChange}
        type="time"
        error={error}
        disabled={!currentDate || disabled}
        isRequired={isRequired}
      />
    </div>
  );
};
